module.exports = __webpack_public_path__ + "img/p2.697f2db2.png";